import dayjs from "@webapp/shared/libs/dayjs";
import { WhiteboardUserSettings } from "@webapp/whiteboards/models/whiteboards-user-settings.models";

export const byOpenedAtDesc = (a: WhiteboardUserSettings, b: WhiteboardUserSettings): number => dayjs(b.openedAt).valueOf() - dayjs(a.openedAt).valueOf();

export const byIndexOfArray =
  (sortingArray: string[]) =>
  (a: { id: string }, b: { id: string }): number =>
    sortingArray.indexOf(a.id) - sortingArray.indexOf(b.id);
